// src/hooks/banks/useGetBanks.js
import { useQuery } from "@tanstack/react-query";
import { getAllBanks } from "../../api/apiBanks";

function useGetBanks(page, perPage, filters = {}) {
    const { isLoading, error, data } = useQuery({
        queryKey: ["banks", page, perPage, filters],
        queryFn: () => getAllBanks(page, perPage, filters),
    });

    return {
        isLoading,
        error,
        banks: data?.data || {},
        meta: data?.data?.meta || {},
    };
}

export default useGetBanks;
